import jsonExport from 'jsonexport/dist';
import moment from "moment";
import {
    BooleanField, BooleanInput, Datagrid, ExportButton, FilterButton,
    List, TextField, TextInput, TopToolbar, downloadCSV, sanitizeListRestProps
} from "react-admin";

const UserFilters = [
    <TextInput label='Nome' source='name' alwaysOn />,
    <TextInput label='Email' source='email' />,
    <BooleanInput label='Ativo' source='active' defaultValue={true} />,
]

const exporter = data => {
    const toExport = data.map(item => {
        return {
            name: item.name,
            email: item.email,
            phone: item.phone,
            active: item.active ? "Ativo" : "Inativo",
            created_at: moment(item.created_at).format('DD/MM/YYYY')
        }
    })
    jsonExport(toExport, {
        headers: ['name', 'email', 'active', 'created_at'],
        rename: ['Nome', 'Email', 'Ativo', 'Criado em'],
    },
        (err, csv) => {
            downloadCSV(csv, `Exportar_Usuarios_${moment().format('YYYY_MM_DD_HH_mm')}`)
        })
}


const UserListActions = (props) => {
    const {
        className,
        exporter,
        filters,
        maxResults,
        ...rest
    } = props;
    return (
        <TopToolbar className={className} {...sanitizeListRestProps(rest)}>
            <FilterButton />
            <ExportButton />
        </TopToolbar>
    );
}

const UserList = (props) => {
    return (
        <List
            exporter={exporter}
            bulkActionButtons={false}
            title={'Usuários'}
            sort={{ field: 'name', order: 'ASC' }}
            filters={UserFilters}
            actions={<UserListActions />}
            {...props}
        >
            <Datagrid rowClick={'edit'}>
                <TextField source="name" label={'Nome'} />
                <TextField source="email" label={'Email'} />
                <TextField source="phone" label={'Telefone'} />
                <BooleanField source="active" label={'Ativo'} />
            </Datagrid>
        </List>
    )
}

export default UserList;